import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { deleteNewsServer, newsServer } from "../../../apis/news";
import { Table } from "antd";
import { useShepherdTour } from "react-shepherd";
import steps from "../../../const/tour/news";
import getNewsColumns from "../../../const/Columns/getNewsColumns";

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);

  // for page tour
  const tourOptions = {
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
    },
    useModalOverlay: false,
  };
  const tour = useShepherdTour({ tourOptions, steps });

  useEffect(() => {
    fetchNews();
    return () => {
      console.log("cancel app");
      console.log(tour);
      // inpRef.current?.click()
      tour.cancel();
    };
  }, []);

  useEffect(() => {
    if (news?.length > 0) {
      const filtered = news?.filter((news) =>
        news.title?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  }, [searchText, news]);

  const fetchNews = async () => {
    try {
      const res = await newsServer({ pageNo: 1 });
      setNews(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteNews = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this News?",
    );
    if (isConfirmed) {
      await deleteNewsServer(id);
      setLoading(true);
      fetchNews();
    }
  };
  const columns = getNewsColumns(deleteNews);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link
                to="/addnews"
                onClick={tour.cancel}
                className="btn add-new btn-primary mb-3"
              >
                Add News
              </Link>
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <a className="btn-ghost" onClick={tour.start}>
                Start Tour
              </a>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredList?.length > 0
                      ? filteredList
                      : news?.length > 0
                        ? news
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default News;
